import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "16",
  fill: "currentColor"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M8.357 11.386a.182.182 0 0 0 .286 0l2.546-3.22a.181.181 0 0 0-.143-.293H9.36V.182C9.361.082 9.28 0 9.18 0H7.816c-.1 0-.182.082-.182.182V7.87h-1.68a.181.181 0 0 0-.143.294zm8.461-.795h-1.364c-.1 0-.181.082-.181.182v3.5H1.727v-3.5c0-.1-.082-.182-.182-.182H.182c-.1 0-.182.082-.182.182v4.5c0 .402.325.727.727.727h15.546a.727.727 0 0 0 .727-.727v-4.5c0-.1-.082-.182-.182-.182" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }